<template>
  <div class="upload-standalone card">
    <div class="file-upload-container">
      <div class="upload-details-container"></div>
      <div class="fields">
        <draggable-fields
          :fields="attachmentFields(tab.id)"
          :visible-fields="
            visibleAttachmentFields(attachment.tabId, attachment)
          "
          resource-name="Attachments"
          :resource="attachment"
          :tab="tab"
          :lock-tabs="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DraggableFields from './DraggableFields.vue';

export default {
  components: {
    DraggableFields
  },
  props: {
    tab: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('entryForm', ['attachmentFields', 'visibleAttachmentFields']),
    attachment() {
      return {
        id: 1,
        fields: this.attachmentFields(this.tab.id),
        tabId: this.tab.id,
        file: [],
        fileId: null,
        order: 1
      };
    }
  }
};
</script>
